export const purchaserIntegers = [];
export const purchaserFloats = [];
export const purchaserIsoStrings = [];
export const purchaserWhiteList = ['id', 'name'];
export const purchaserOptimisticList = [...purchaserWhiteList];
